// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","FilterLinks__link":"ce_a bho_h bho_kh bho_we bho_su bho_vt bho_sw bho_sn"};